export const CriminalHearing = [
    { value: 'AIJ', label: 'AIJ' },
    { value: 'Conciliação', label: 'Conciliação' },
    { value: 'Justificação', label: 'Justificação' },
    { value: 'Outros', label: 'Outros' },
];